module.exports = __webpack_public_path__ + "static/media/Products (3).d47ebb64.jpg";